/* eslint-disable max-len */
import { TYPES_BY_CLASS } from './constants';

export const track = (key) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`fit-compatibility-drawer.${key}`);
  }
};

const validator = (str, validation) => {
  if (!str) return false;

  const lowerStr = str.toLowerCase();

  if (validation === 'washer' && lowerStr.includes('dishwasher')) {
    return false;
  }

  return lowerStr.includes(validation);
};

export const getApplianceTypeByClassNumber = (productInfo) => {
  const { classNumber, subClassNumber } = productInfo || {};
  if (!productInfo || classNumber === null || subClassNumber === null) {
    return null;
  }

  const matchedType = Object.keys(TYPES_BY_CLASS).find(
    (type) => TYPES_BY_CLASS[type].class === classNumber
        && TYPES_BY_CLASS[type].subclasses.includes(subClassNumber)
  ) ?? null;

  return matchedType;
};

export const getApplianceType = (data) => {
  const productInfo = data?.searchModel?.products?.[0]?.info || data?.searchModel?.info || data?.product?.info;
  const typeFromClass = getApplianceTypeByClassNumber(productInfo);
  if (typeFromClass) {
    return typeFromClass;
  }
  return null;
};

export const isBuiltInAppliance = (data) => {
  const product = data?.product;
  if (!product?.specificationGroup) return false;

  return product.specificationGroup.some((group) => group?.specifications?.some(
    (spec) => {
      return (
        spec?.specName?.toLowerCase() === 'installation type'
        && spec?.specValue?.toLowerCase() === 'built-in'
      );
    }
  )
  );
};